import { useEffect } from "react";

export default function useToggleClass(elementId, isActive, className) {
  useEffect(() => {
    const element = document.getElementById(elementId);
    if (isActive) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  }, [elementId, isActive, className]);
}
